export default __webpack_public_path__ + "static/media/3-star.d65f9e8f.png";